export const ACTIVITY_TYPE = {
  comment: 'comment',
  discovery: 'discovery',
  discussion: 'discussion',
  architecture: 'architecture',
  quiz: 'quiz',
};
